module.exports = __webpack_public_path__ + "static/media/pp4.35b76acc.jpg";